import { createSelector } from 'reselect';

/**
 * Direct selector to the home state domain
 */

const selectHomeDomain = state => state.homepage;

const makeSelectProcessing = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.processing,
  );
const makeSelectContentTypes = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.contentTypes,
  );
const makeSelectAssessments = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.assessments,
  );

const makeSelectNews = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.news,
  );
const makeSelectBlogs = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.blogs,
  );
const makeSelectGuideMeOpened = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.guideMeOpened,
  );

export {
  makeSelectContentTypes,
  makeSelectProcessing,
  makeSelectAssessments,
  makeSelectNews,
  makeSelectBlogs,
  makeSelectGuideMeOpened,
};
